// extracted by mini-css-extract-plugin
module.exports = {"c149jlnm":"c149jlnm","b1q6ndez":"b1q6ndez"};